import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from 'src/app/modules/common/models/PagedResponseDTO';
import {AtcDTO} from 'src/app/modules/pbm/models/AtcDTO';

@Injectable({
  providedIn: 'root'
})
export class AtcService {

  private url = environment.baseUrl + '/atc';

  constructor(private httpClient: HttpClient) {
  }

  getListOfAtcCodes(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<AtcDTO>> {
    return this.httpClient.post<PagedResponseDTO<AtcDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveAtcCode(atcDTO: AtcDTO): Observable<AtcDTO> {
    return this.httpClient.post<AtcDTO>(this.url, atcDTO);
  }

  deleteAtcCode(atcId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + atcId);
  }

  getAtcCode(atcId: number): Observable<AtcDTO> {
    return this.httpClient.get<AtcDTO>(this.url + '/' + atcId);
  }
}
